module.exports = __webpack_public_path__ + "static/media/bed.f87e7689.svg";